<template>
    <div class="sty-section" :class="bemFacets">
        <div class="grid--container">
            <sty-header :facets="['section-title']">
                <h2 class="u-reset u-reset__sty" :id="anchor" v-text="sectionTitle"/>
            </sty-header>
        </div>

        <div class="grid--container">
            <div class="grid--row sty-section--articles">
                <div class="grid--col sty-section--article">
                    <sty-header>
                        <h3 class="u-reset u-reset__sty">
                            Spacings
                        </h3>
                    </sty-header>

                    <div class="grid--row">
                        <div class="grid--col sty-section--form-example">
                            <sty-header>
                                <h4 class="u-reset u-reset__sty">
                                    Form fields
                                </h4>
                            </sty-header>

                            <div class="grid--row">
                                <div class="grid--col sty-section--col">
                                    <div class="form">
                                        <div class="form--field-row">
                                            <div class="form--field">
                                                <ui-input value="" :facets="['base']"/>
                                            </div>
                                            <div class="form--field">
                                                <ui-input value="" :facets="['base']"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="grid--col sty-section--form-example">
                            <sty-header>
                                <h4 class="u-reset u-reset__sty">
                                    Fieldsets
                                </h4>
                            </sty-header>

                            <div class="grid--row">
                                <div class="grid--col sty-section--col">
                                    <div class="form">
                                        <div class="form--fieldset-row">
                                            <fieldset class="form--fieldset">
                                                <div class="form--field-row">
                                                    <div class="form--field">
                                                        <ui-input value="" :facets="['base']"/>
                                                    </div>
                                                    <div class="form--field">
                                                        <ui-input value="" :facets="['base']"/>
                                                    </div>
                                                </div>
                                            </fieldset>
                                            <fieldset class="form--fieldset">
                                                <div class="form--field-row">
                                                    <div class="form--field">
                                                        <ui-input value="" :facets="['base']"/>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- primary input: text -->
                <div class="grid--col sty-section--article">
                    <div class="grid--row">
                        <div class="grid--col sty-section--col">
                            <sty-header>
                                <h3 class="u-reset u-reset__sty" v-text="forms.primary.text.options.title"/>
                                <div class="sty-section--floating-label-switch">
                                    <ui-model-provider v-model="forms.primary.text.options.hasFloatingLabel"
                                            v-slot="{ value, updateValue }">
                                        <ui-checkbox :value="value" @change="updateValue">
                                            <template v-slot:label>
                                                Activate floating labels
                                            </template>
                                        </ui-checkbox>
                                    </ui-model-provider>
                                </div>
                            </sty-header>
                        </div>
                    </div>

                    <div class="grid--row">
                        <div class="grid--col sty-section--form-example"
                                v-for="(section, sectionIdx) in forms.primary.text.sections"
                                :key="sectionIdx">
                            <sty-header>
                                <h4 class="u-reset u-reset__sty" v-text="section.title"/>
                            </sty-header>

                            <div class="grid--row">
                                <div class="grid--col sty-section--col">
                                    <div class="form">
                                        <div class="form--field-row">
                                            <div class="form--field"
                                                    v-for="(example, exampleIdx) in section.examples"
                                                    :key="exampleIdx">
                                                <pre class="sty-section--model-debugger"><code>{{ example.value || ' ' }}</code></pre>
                                                <ui-model-provider v-model="example.value" v-slot="{ value, updateValue }">
                                                    <ui-input v-bind="bindFieldData(example, forms.primary.text.options)"
                                                            :value="value"
                                                            @input="updateValue">
                                                        <template v-slot:label>
                                                            {{ bindFieldData(example, forms.primary.text.options).label }}
                                                        </template>
                                                        <form-field-messages :messages="example.messages"
                                                                v-slot:messages/>
                                                    </ui-input>
                                                </ui-model-provider>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- primary input: textarea -->
                <div class="grid--col sty-section--article">
                    <div class="grid--row">
                        <div class="grid--col sty-section--col">
                            <sty-header>
                                <h3 class="u-reset u-reset__sty" v-text="forms.primary.textarea.options.title"/>
                                <div class="sty-section--floating-label-switch">
                                    <ui-model-provider v-model="forms.primary.textarea.options.hasFloatingLabel"
                                            v-slot="{ value, updateValue }">
                                        <ui-checkbox :value="value" @change="updateValue">
                                            <template v-slot:label>
                                                Activate floating labels
                                            </template>
                                        </ui-checkbox>
                                    </ui-model-provider>
                                </div>
                            </sty-header>
                        </div>
                    </div>

                    <div class="grid--row">
                        <div class="grid--col sty-section--form-example"
                                v-for="(section, sectionIdx) in forms.primary.textarea.sections"
                                :key="sectionIdx">
                            <sty-header>
                                <h4 class="u-reset u-reset__sty" v-text="section.title"/>
                            </sty-header>

                            <div class="grid--row">
                                <div class="grid--col sty-section--col">
                                    <div class="form">
                                        <div class="form--field-row">
                                            <div class="form--field"
                                                    v-for="(example, exampleIdx) in section.examples"
                                                    :key="exampleIdx">
                                                <pre class="sty-section--model-debugger"><code>{{ example.value || ' ' }}</code></pre>
                                                <ui-model-provider v-model="example.value" v-slot="{ value, updateValue }">
                                                    <ui-textarea v-bind="bindFieldData(example, forms.primary.textarea.options)"
                                                            :value="value"
                                                            @input="updateValue">
                                                        <template v-slot:label>
                                                            {{ bindFieldData(example, forms.primary.textarea.options).label }}
                                                        </template>
                                                        <form-field-messages :messages="example.messages"
                                                                v-slot:messages/>
                                                    </ui-textarea>
                                                </ui-model-provider>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- primary input: select -->
                <div class="grid--col sty-section--article">
                    <div class="grid--row">
                        <div class="grid--col sty-section--col">
                            <sty-header>
                                <h3 class="u-reset u-reset__sty" v-text="forms.primary.select.simple.options.title"/>
                            </sty-header>
                        </div>
                    </div>

                    <div class="grid--row">
                        <div class="grid--col sty-section--form-example"
                                v-for="(section, sectionIdx) in forms.primary.select.simple.sections"
                                :key="sectionIdx">
                            <sty-header>
                                <h4 class="u-reset u-reset__sty" v-text="section.title"/>
                            </sty-header>

                            <div class="grid--row">
                                <div class="grid--col sty-section--col">
                                    <div class="form">
                                        <div class="form--field-row">
                                            <div class="form--field"
                                                    v-for="(example, exampleIdx) in section.examples"
                                                    :key="exampleIdx">
                                                <pre class="sty-section--model-debugger"><code>{{ example.value || ' ' }}</code></pre>
                                                <ui-model-provider v-model="example.value"
                                                        v-slot="{ value, updateValue }">
                                                    <ui-select v-bind="bindFieldData(example, forms.primary.select.simple.options)"
                                                            :value="value"
                                                            @change="updateValue">
                                                        <template v-slot:label>
                                                            {{ bindFieldData(example, forms.primary.select.simple.options).label }}
                                                        </template>
                                                        <ui-option disabled
                                                                value=""
                                                                v-if="example.placeholder">
                                                            {{ example.placeholder }}
                                                        </ui-option>
                                                        <ui-option :value="item.value"
                                                                v-for="(item, index) in bindFieldData(example, forms.primary.select.simple.options).items"
                                                                :key="index">
                                                            {{ item.value }}
                                                        </ui-option>
                                                        <form-field-messages :messages="example.messages"
                                                                v-slot:messages/>
                                                    </ui-select>
                                                </ui-model-provider>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid--col sty-section--article">
                    <div class="grid--row">
                        <div class="grid--col sty-section--col">
                            <sty-header>
                                <h3 class="u-reset u-reset__sty" v-text="forms.primary.select.nested.options.title"/>
                            </sty-header>
                        </div>
                    </div>

                    <div class="grid--row">
                        <div class="grid--col sty-section--form-example"
                                v-for="(section, sectionIdx) in forms.primary.select.nested.sections"
                                :key="sectionIdx">
                            <sty-header>
                                <h4 class="u-reset u-reset__sty" v-text="section.title"/>
                            </sty-header>

                            <div class="grid--row">
                                <div class="grid--col sty-section--col">
                                    <div class="form">
                                        <div class="form--field-row">
                                            <div class="form--field"
                                                    v-for="(example, exampleIdx) in section.examples"
                                                    :key="exampleIdx">
                                                <pre class="sty-section--model-debugger"><code>{{ example.value || ' ' }}</code></pre>
                                                <ui-model-provider v-model="example.value" v-slot="{ value, updateValue }">
                                                    <ui-select v-bind="bindFieldData(example, forms.primary.select.nested.options)"
                                                            :value="value"
                                                            @change="updateValue">
                                                        <template v-slot:label>
                                                            {{ bindFieldData(example, forms.primary.select.nested.options).label }}
                                                        </template>
                                                        <ui-optgroup :label="item.label"
                                                                v-for="(item, optGroupIndex) in bindFieldData(example, forms.primary.select.nested.options).items"
                                                                :key="optGroupIndex">
                                                            <ui-option :value="option.value"
                                                                    v-for="(option, optionIndex) in item.items"
                                                                    :key="optionIndex">
                                                                {{ option.value }}
                                                            </ui-option>
                                                        </ui-optgroup>
                                                        <form-field-messages :messages="example.messages"
                                                                v-slot:messages/>
                                                    </ui-select>
                                                </ui-model-provider>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- primary boolean: radio -->
                <div class="grid--col sty-section--article">
                    <div class="grid--row">
                        <div class="grid--col sty-section--col">
                            <sty-header>
                                <h3 class="u-reset u-reset__sty" v-text="forms.primary.radio.options.title"/>
                            </sty-header>
                        </div>
                    </div>

                    <div class="grid--row">
                        <div class="grid--col sty-section--form-example"
                                v-for="(section, sectionIdx) in forms.primary.radio.sections"
                                :key="sectionIdx">
                            <sty-header>
                                <h4 class="u-reset u-reset__sty" v-text="section.title"/>
                            </sty-header>

                            <div class="grid--row">
                                <div class="grid--col sty-section--col">
                                    <div class="form">
                                        <div class="form--field-row">
                                            <div class="form--field"
                                                    v-for="(example, exampleIdx) in section.examples"
                                                    :key="exampleIdx">
                                                <pre class="sty-section--model-debugger"><code>{{ example.value || ' ' }}</code></pre>
                                                <ui-model-provider v-model="example.value" v-slot="{ value, updateValue }">
                                                    <div class="ui-form-field ui-form-field__base ui-form-field__list"
                                                            :class="listFacets(example.facets)">
                                                        <div class="ui-form-field--title-label">
                                                            {{ example.label }}
                                                        </div>
                                                        <div class="ui-form-field--row">
                                                            <div class="ui-form-field--input-container"
                                                                    v-for="(item, index) in bindFieldData(example, forms.primary.checkbox.options).items"
                                                                    :key="index">
                                                                <ui-radio class="ui-form-field--list-item"
                                                                        :has-errors="example['has-errors']"
                                                                        :facets="item.facets"
                                                                        :checked="value === item.value"
                                                                        v-bind="item"
                                                                        @change="updateValue">
                                                                    <template v-slot:label>
                                                                        {{ item.value }}
                                                                    </template>
                                                                </ui-radio>
                                                            </div>
                                                        </div>
                                                        <form-field-messages :messages="example.messages"/>
                                                    </div>
                                                </ui-model-provider>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- primary boolean: checkbox -->
                <div class="grid--col sty-section--article">
                    <div class="grid--row">
                        <div class="grid--col sty-section--col">
                            <sty-header>
                                <h3 class="u-reset u-reset__sty" v-text="forms.primary.checkbox.options.title"/>
                            </sty-header>
                        </div>
                    </div>

                    <div class="grid--row">
                        <div class="grid--col sty-section--form-example"
                                v-for="(section, sectionIdx) in forms.primary.checkbox.sections"
                                :key="sectionIdx">
                            <sty-header>
                                <h4 class="u-reset u-reset__sty" v-text="section.title"/>
                            </sty-header>

                            <div class="grid--row">
                                <div class="grid--col sty-section--col">
                                    <div class="form">
                                        <div class="form--field-row">
                                            <div class="form--field"
                                                    v-for="(example, exampleIdx) in section.examples"
                                                    :key="exampleIdx">
                                                <pre class="sty-section--model-debugger"><code>{{ example.value || ' ' }}</code></pre>
                                                <ui-model-provider v-model="example.value">
                                                    <template v-slot="{ hasItem, updateValue }">
                                                        <div class="ui-form-field ui-form-field__base ui-form-field__list"
                                                                :class="listFacets(example.facets)">
                                                            <div class="ui-form-field--title-label">
                                                                {{ example.label }}
                                                            </div>
                                                            <div class="ui-form-field--row">
                                                                <div class="ui-form-field--input-container"
                                                                        v-for="(item, index) in bindFieldData(example, forms.primary.checkbox.options).items"
                                                                        :key="index">
                                                                    <ui-checkbox class="ui-form-field--list-item"
                                                                            :has-errors="example['has-errors']"
                                                                            :facets="item.facets"
                                                                            :checked="hasItem(item.value)"
                                                                            v-bind="item"
                                                                            @change="updateValue">
                                                                        <template v-slot:label>
                                                                            {{ item.value }}
                                                                        </template>
                                                                    </ui-checkbox>
                                                                </div>
                                                            </div>
                                                            <form-field-messages :messages="example.messages"/>
                                                        </div>
                                                    </template>
                                                </ui-model-provider>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import UiInput from '@dreipol/vue-ui/src/components/form/input/input.vue';
    import UiTextarea from '@dreipol/vue-ui/src/components/form/textarea/textarea.vue';
    import UiCheckbox from '@dreipol/vue-ui/src/components/form/checkbox/checkbox.vue';
    import UiRadio from '@dreipol/vue-ui/src/components/form/radio/radio.vue';
    import UiSelect from '@dreipol/vue-ui/src/components/form/select/select.vue';
    import UiOption from '@dreipol/vue-ui/src/components/form/option/option.vue';
    import UiOptgroup from '@dreipol/vue-ui/src/components/form/optgroup/optgroup.vue';
    import UiModelProvider from '@dreipol/vue-ui/src/components/form/model-provider/model-provider.vue';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import StyHeader from 'framework/styleguide/header';
    import FormFieldMessages from 'framework/global-components/form-field-messages/form-field-messages.vue';
    import formConfig from './form-config';

    export default {
        components: {
            StyHeader,
            UiInput,
            UiModelProvider,
            UiTextarea,
            UiCheckbox,
            UiRadio,
            UiSelect,
            UiOption,
            UiOptgroup,
            FormFieldMessages,
        },
        mixins: [
            bemMixin('sty-section'),
        ],
        props: {
            anchor: {
                type: String,
                required: true,
            },
            sectionTitle: {
                type: String,
                required: true,
            },
        },
        data() {
            return formConfig;
        },
        methods: {
            listFacets(facets) {
                return facets && facets.map(facet => this.bemAdd(facet, '', 'ui-form-field'));
            },
            bindFieldData(fieldData, fieldConfig) {
                return {
                    ...fieldData,
                    ...fieldConfig,
                    facets: [
                        ...(fieldData.facets || []),
                        ...(fieldConfig.facets || []),
                    ],
                };
            },
        },
    };
</script>
